import React, { useMemo } from "react";
import "./SurveySelectNew.scss";

const SurveySelectFive = ({
  id,
  content,
  setAnswersList,
  answersList,
  isSoleQuestion,
  submit,
}) => {
  const answerIdx = useMemo(
    () => answersList.findIndex((item) => item.questionId === id),
    [answersList, id]
  );

  const answer = useMemo(
    () => (answerIdx >= 0 ? answersList[answerIdx].answers[0].degree : null),
    [answerIdx, answersList]
  );

  const saveAnswer = (degree) => {
    if (answerIdx === -1) {
      let newScreenAnswersList = answersList;
      newScreenAnswersList.push({
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      });

      setAnswersList([...newScreenAnswersList]);
    } else {
      let newScreenAnswersList = answersList;
      newScreenAnswersList[answerIdx] = {
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      };

      setAnswersList([...newScreenAnswersList]);
    }
  };

  return (
    <div className="survey-select-indiv">
      <p className="survey-q">{content}</p>
      <div className="survey-select-inner">
        <ul className="list">
          <li className="list__item">
            <p className="radio-top">
              전혀
              <br />
              그렇지 않다
            </p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              id={`${id}-opt-1`}
              value={1}
              onChange={() => {
                saveAnswer(1);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              checked={answer === 1 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-1`}
              id={`${id}-label-1`}
              className="label"
            ></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">그렇지 않다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={2}
              onChange={() => {
                saveAnswer(2);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              id={`${id}-opt-2`}
              checked={answer === 2 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-2`}
              id={`${id}-label-2`}
              className="label"
            ></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">모르겠다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={3}
              onChange={() => {
                saveAnswer(3);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              id={`${id}-opt-3`}
              checked={answer === 3 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-3`}
              id={`${id}-label-3`}
              className="label"
            ></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">그렇다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={4}
              onChange={() => {
                saveAnswer(4);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              id={`${id}-opt-4`}
              checked={answer === 4 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-4`}
              id={`${id}-label-4`}
              className="label"
            ></label>
          </li>
          <li className="list__item">
            <p className="radio-top radio-top-ex">매우 그렇다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              value={5}
              onChange={() => {
                saveAnswer(5);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              id={`${id}-opt-5`}
              checked={answer === 5 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-5`}
              id={`${id}-label-5`}
              className="label"
            ></label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SurveySelectFive;
